import { getRuntimeConfig } from "@/config/runtime";

/** This UI's version (the VERSION file it was built from) and the release it was deployed as (empty locally). */
export interface AppVersion {
  version: string;
  release: string;
}

export function appVersion(): AppVersion {
  return { version: __APP_VERSION__, release: getRuntimeConfig().appRelease };
}

/** "2.0.0 (v2.0.0-rc.9)", or just "2.0.0" when there's no release (local builds) or it adds nothing. */
export function versionLine({ version, release }: AppVersion): string {
  if (!release || release === version || release === `v${version}`) return version;
  return `${version} (${release})`;
}

/**
 * Plain-text details for a support ticket. `server` is the backend's own version/release, when it answered;
 * labels come from the caller (translated).
 */
export function aboutDetails(
  app: AppVersion,
  server: AppVersion | null,
  labels: { app: string; server: string; unavailable: string },
): string {
  return [
    `${labels.app}: ${versionLine(app)}`,
    `${labels.server}: ${server ? versionLine(server) : labels.unavailable}`,
  ].join("\n");
}

/** True when the UI and the server it talks to aren't the same release (e.g. mid-deploy). */
export function isMismatch(app: AppVersion, server: AppVersion | null): boolean {
  if (!server) return false;
  if (app.version !== server.version) return true;
  return Boolean(app.release && server.release && app.release !== server.release);
}
